<template>
  <div class="authenticationinfo">
    <div class="description" v-dompurify-html="authenticationinfo.description"></div>
    <div class="form" v-dompurify-html="authenticationinfo.form"></div>
  </div>
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'AuthenticationInfo',
  props: ['authenticationinfo'],
  components: {}
})
class AuthenticationInfo extends Vue {
  @Prop authenticationinfo
}

export default AuthenticationInfo
</script>

<style scoped lang="less">
.authenticationinfo {
  display: flex;
    flex-direction: column;
}
</style>